import { useReveal } from "@/hooks/useReveal";

const CARDS = [
  {
    icon: "ri-verified-badge-line",
    title: "Our certifications work here as-is",
    body: "South Africa has no national organic production or labelling regulation, so our USDA and EU Organic seals are recognised without an equivalence procedure. There is no additional certification step and no waiting period.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Documentation ready on day one",
    body: "Every shipment leaves with certificates of analysis, organic certificates, phytosanitary documentation and pallet certificates. Label localisation to South African requirements is agreed with the importer before shipping.",
  },
  {
    icon: "ri-stack-line",
    title: "A portfolio that fits four channels at once",
    body: "Retail, hospitality, food manufacturing and private label can all be supplied from the same production run and consolidated into a single container.",
  },
];

export default function WhySouthAfrica() {
  const headingRef = useReveal<HTMLDivElement>();
  const gridRef = useReveal<HTMLDivElement>();

  return (
    <section className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={headingRef} className="reveal">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Why we are starting here
          </h2>
          <p className="mt-4 text-ink/70 text-lg max-w-2xl">
            Three practical reasons South Africa is the first market we are
            opening on the continent.
          </p>
        </div>

        <div ref={gridRef} className="reveal mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {CARDS.map((card) => (
            <div
              key={card.title}
              className="bg-white rounded-lg p-7 border border-cream-dark/70 flex flex-col transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-brand/10">
                <i className={`${card.icon} text-brand text-2xl`}></i>
              </div>
              <h3 className="mt-5 text-ink font-serif text-xl font-semibold">
                {card.title}
              </h3>
              <p className="mt-3 text-ink/70 text-[17px] leading-relaxed">
                {card.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}